import React, { useState } from 'react';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { webhooksKey } from '@dashboard/lib/queryKeys';
import Button from '@dashboard/components/Button';
import PageHeader from '@dashboard/components/PageHeader';
import { PlusIcon } from '@heroicons/react/24/outline';
import WebhookTable from './components/WebhookTable';
import WebhookCreateDialog from './components/WebhookCreateDialog';
import Link from '@/dashboard/components/Link';

const SettingsWebhooks = () => {
  const [showCreateWebhookDialog, setShowCreateWebhookDialog] = useState(false);
  const { sellerId, token } = useAuth();

  const {
    data: webhooks,
    isLoading: isLoadingWebhooks,
    isError: isErrorWebhooks,
  } = useQuery({
    queryKey: webhooksKey(sellerId),
    queryFn: () => fetcher(`/sellers/${sellerId}/webhooks`, token),
    enabled: !!sellerId,
  });

  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Webhooks"
        description={
          <>
            Configure webhooks to receive real-time notifications when events occur in your store.{' '}
            <Link target="_blank" to="/docs/api/v1/webhooks/signature">
              View documentation
            </Link>
          </>
        }
        actions={
          <Button appearance="primary" onClick={() => setShowCreateWebhookDialog(true)}>
            Create webhook
            <PlusIcon className="w-4 h-4 ml-2 align-baseline" />
          </Button>
        }
      />

      <div className="mb-32">
        <WebhookTable data={webhooks} isLoading={isLoadingWebhooks} isError={isErrorWebhooks} />

        <WebhookCreateDialog
          open={showCreateWebhookDialog}
          onClose={() => setShowCreateWebhookDialog(false)}
        />
      </div>
    </div>
  );
};

export default SettingsWebhooks;
